// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoTablo_root__1Hon2","insert":"InfoTablo_insert__eHurG","list":"InfoTablo_list__gYdeP"};